<template>
    <div class="home_wrap">
        <div>
            <van-nav-bar :title="title" left-text="" left-arrow :fixed="true" @click-left="onClickLeft">
                <template #right>
                    <div class="hisBtn" @click="toHistory(4)">Histórico</div>
                </template>
            </van-nav-bar>
        </div>
        <div class="big-box">
            <div class="main-box">
                <div class="main-title">
                    <div>Valor da sorte atual <span>0</span></div>
                    <div>Durante a atividade já apostou 0, ainda precisa apostar 2.000 para ter 1 chance na roleta!
                    </div>
                </div>
                <div class="main-game">
                    <div class="container">
                        <img src="../../assets/images/Turntable/Turntable.png" alt="">
                        <div class="prizeList">
                            <div class="prizeItem" v-for="(item, index) in prizeList" :key="index"
                                :style="'transform:rotate(' + index * 36 + 'deg)'">
                                <p>{{ item.num }}</p>
                            </div>
                        </div>
                        <div class="prizeList-btn" @click="spin">
                            <span>Sorteio de roleta</span>
                            <img src="../../assets/images/Turntable/turnTableBtn.png" alt="">
                        </div>
                    </div>
                    <div class="bottom-btn">
                        <div class="btnItem">
                            <div>Sorteio de roleta</div>
                            <div class="num">999 Pontos de Sorte</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="rightInfoBox">
                <div class="tab-head">
                    <van-tabs v-model="active" class="van-tabs__wrap--scrollable" animated offset-top="1.2rem"
                        lazy-render @change="tabChange">
                        <van-tab title="Notificação de Prêmio" />
                        <van-tab title="Meus Registros" />
                    </van-tabs>
                </div>
                <div class="tab-content" v-if="active == 0">
                    <div class="tab-list">
                        <ul class="tab-list-items">
                            <li class="tab-list-item">
                                <div class="list-left">
                                    <img src="https://img2.thethsdnadagvx.com/gjlm297/c1e3e0dc-bb07-4f12-af7e-80931d663705.png"
                                        alt="">
                                    <div class="winListName">
                                        <p>12/08 18:48</p>
                                        <p>s**a obtê -lo em Sorteio de roleta</p>
                                    </div>
                                </div>
                                <p class="list-right">1777,00</p>
                            </li>
                            <li class="tab-list-item">
                                <div class="list-left">
                                    <img src="https://img2.thethsdnadagvx.com/gjlm297/c1e3e0dc-bb07-4f12-af7e-80931d663705.png"
                                        alt="">
                                    <div class="winListName">
                                        <p>12/08 18:48</p>
                                        <p>s**a obtê -lo em Sorteio de roleta</p>
                                    </div>
                                </div>
                                <p class="list-right">1777,00</p>
                            </li>
                            <li class="tab-list-item">
                                <div class="list-left">
                                    <img src="https://img2.thethsdnadagvx.com/gjlm297/c1e3e0dc-bb07-4f12-af7e-80931d663705.png"
                                        alt="">
                                    <div class="winListName">
                                        <p>12/08 18:48</p>
                                        <p>s**a obtê -lo em Sorteio de roleta</p>
                                    </div>
                                </div>
                                <p class="list-right">1777,00</p>
                            </li>
                            <li class="tab-list-item">
                                <div class="list-left">
                                    <img src="https://img2.thethsdnadagvx.com/gjlm297/c1e3e0dc-bb07-4f12-af7e-80931d663705.png"
                                        alt="">
                                    <div class="winListName">
                                        <p>12/08 18:48</p>
                                        <p>s**a obtê -lo em Sorteio de roleta</p>
                                    </div>
                                </div>
                                <p class="list-right">1777,00</p>
                            </li>
                            <li class="tab-list-item">
                                <div class="list-left">
                                    <img src="https://img2.thethsdnadagvx.com/gjlm297/c1e3e0dc-bb07-4f12-af7e-80931d663705.png"
                                        alt="">
                                    <div class="winListName">
                                        <p>12/08 18:48</p>
                                        <p>s**a obtê -lo em Sorteio de roleta</p>
                                    </div>
                                </div>
                                <p class="list-right">1777,00</p>
                            </li>
                            <li class="tab-list-item">
                                <div class="list-left">
                                    <img src="https://img2.thethsdnadagvx.com/gjlm297/c1e3e0dc-bb07-4f12-af7e-80931d663705.png"
                                        alt="">
                                    <div class="winListName">
                                        <p>12/08 18:48</p>
                                        <p>s**a obtê -lo em Sorteio de roleta</p>
                                    </div>
                                </div>
                                <p class="list-right">1777,00</p>
                            </li>
                            <li class="tab-list-item">
                                <div class="list-left">
                                    <img src="https://img2.thethsdnadagvx.com/gjlm297/c1e3e0dc-bb07-4f12-af7e-80931d663705.png"
                                        alt="">
                                    <div class="winListName">
                                        <p>12/08 18:48</p>
                                        <p>s**a obtê -lo em Sorteio de roleta</p>
                                    </div>
                                </div>
                                <p class="list-right">1777,00</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="tab-content" v-if="active == 1">
                    <div class="tab-list-empty-text">Sem Registros</div>
                </div>
            </div>
            <div class="turntableRules">
                <p>
                    Você pode ter uma chance apostando 2.000 todos os dias. Quanto mais você apostar, mais bônus
                    receberá.
                </p>
            </div>
        </div>
        <ft></ft>
    </div>
</template>
<script>
import Vue from "vue";
import ft from "../../components/ft.vue";
import {
    NavBar,
    Tab,
    Tabs,
} from "vant";
Vue.use(NavBar).use(Tab).use(Tabs);

export default {
    name: "turnTable",
    components: {
        ft,
    },
    data() {
        return {
            title: "Roleta",
            prizeList: [
                {
                    num: 1
                },
                {
                    num: 2
                },
                {
                    num: 3
                },
                {
                    num: 4
                },
                {
                    num: 5
                },
                {
                    num: 6
                },
                {
                    num: 7
                },
                {
                    num: 8
                },
                {
                    num: 9
                },
                {
                    num: 10
                },
            ],
            active: 0,
        }
    },
    created() {

    },
    methods: {
        onClickLeft() {
            this.$router.push("/");
        },
        tabChange(v) {
            this.active = v;
        },
        toHistory(v) {
            this.$router.push({ name: "activity", query: { tab: v } });
        },
        spin(){
            console.log("转动转盘")
        }
    }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/variables.less";

.home_wrap {
    width: 100%;
    min-height: 100vh;
    background-color: @activityColor;
    padding-top: 1.2rem;
    // padding-bottom: 1.2rem;
}

/deep/ .van-nav-bar {
    background: @secondary-color;
}

/deep/ .van-nav-bar .van-icon {
    color: #fff;
}

/deep/ .van-nav-bar__title {
    color: #fff;
    font-size: .38rem;
}

/deep/.van-tab__text {
    font-size: 0.32rem;
    color: #fff;
}

/deep/.van-tabs__line {
    background: @ButtonColor;
    height: 0.04rem;
    width: 35%;
}

/deep/ .van-tabs__nav {
    padding-left: 0;
    padding-right: 0;
    background-color: @secondary-color;
}

/deep/ .van-tab--active .van-tab__text {
    color: @rechargeColor;
}

.hisBtn {
    color: @ButtonColor;
    font-size: .32rem;
}

.big-box {
    width: 100%;
    // text-align: center;
    // display: flex;
    // justify-items: center;

    .main-box {
        box-sizing: border-box;
        width: 95%;
        background-color: @secondary-color;
        border-radius: .14rem;
        padding: .2rem;
        margin: 0 auto;
        margin-top: .2rem;

        .main-title {
            border-bottom: 0.01rem solid @bodercolor;
            padding-bottom: .2rem;

            div {
                color: @textcolor1;
                font-size: .32rem;
                line-height: .5rem;

                span {
                    color: @textcolor4;
                }
            }
        }

        .main-game {
            .container {
                position: relative;
                width: 6.7rem;
                height: 6.7rem;
                margin: 0 auto;
                margin-bottom: .24rem;
                margin-top: 1rem;

                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                }

                .prizeList {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    background-repeat: no-repeat;
                    background-position: 50%;
                    background-size: contain;
                    overflow: hidden;

                    .prizeItem {
                        position: absolute;
                        top: -50%;
                        width: 100%;
                        height: 100%;
                        text-align: center;
                        transform-origin: center bottom;

                        p {
                            position: absolute;
                            width: 100%;
                            bottom: 33%;
                            left: 0;
                            font-size: .36rem;
                            color: #fff;
                        }
                    }
                }

                .prizeList-btn {
                    position: absolute;
                    bottom: 50%;
                    left: 50%;
                    transform: translate(-50%, 25%);
                    text-align: center;
                    cursor: pointer;
                    width: 4.3rem;
                    height: 4.923rem;

                    span {
                        position: absolute;
                        transform: translate(-50%, -50%);
                        bottom: -12%;
                        left: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: .33rem;
                        font-weight: 700;
                        color: #fff;
                        line-height: normal;
                        width: 1.72rem;
                        height: 1.72rem;
                        text-wrap: balance;
                        z-index: 9;
                    }

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }

            .bottom-btn {
                // padding: .2rem;
                display: flex;

                .btnItem {
                    padding: .3rem;
                    background-color: #9778ff;
                    font-size: .3rem;
                    border-radius: .2rem;
                    color: #fff;
                    text-align: center;

                    .num {
                        font-size: .2rem;
                    }
                }

            }
        }
    }

    .rightInfoBox {
        box-sizing: border-box;
        width: 95%;
        background-color: @secondary-color;
        border-radius: .14rem;
        padding: .2rem;
        margin: 0 auto;
        margin-top: .2rem;

        .tab-head {
            border-bottom: 0.01rem solid @bodercolor;
        }

        .tab-content {
            .tab-list {
                .tab-list-item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding-left: .2rem;
                    border-bottom: 0.01rem solid @bodercolor;
                    padding-bottom: .1rem;

                    // padding: .24rem;
                    .list-left {
                        display: flex;
                        align-items: center;
                        gap: .2rem;

                        .winListName {
                            display: flex;
                            gap: .4rem;

                            p {
                                color: @textcolor1;
                                font-size: .3rem;
                                // margin-left: .2rem;
                            }
                        }

                        img {
                            width: 0.6rem;
                            height: .6rem;
                        }
                    }

                    .list-right {
                        font-size: .3rem;
                        color: @textcolor4;
                    }
                }

                .tab-list-item:last-child {
                    border-bottom: none;
                    margin-bottom: .1rem;
                }
            }

            .tab-list-empty-text {
                padding: 16px;
                color: #fff;
                font-size: 14px;
                text-align: center;
            }
        }
    }

    .turntableRules {
        box-sizing: border-box;
        width: 95%;
        background-color: @secondary-color;
        border-radius: .14rem;
        padding: .34rem;
        margin: 0 auto;
        margin-top: .2rem;
        box-shadow: 0 -.003rem 0 .01rem rgba(0, 0, 0, .1);

        p {
            color: @textcolor1;
            font-weight: 700;
        }
    }
}

.svg_icon {
    fill: #fff;
    margin-left: 1rem;
}
</style>